// extracted by mini-css-extract-plugin
export var formContainer = "_jg-0";
export var message = "_jg-1";